import { Localization } from "../../../common/localizable-component";
import { ChipLocalization } from "./chip-types";

export const CHIP_LOCALIZATION: Localization<ChipLocalization> = {
  en: {
    removeItem: "Remove item"
  },
  de: {
    removeItem: "Element entfernen"
  },
  sv: {
    removeItem: "Ta bort objekt"
  },
  nl: {
    removeItem: "Item verwijderen"
  },
  it: {
    removeItem: "Rimuovere l'articolo"
  },
  hu: {
    removeItem: "Tétel eltávolítása"
  },
  da: {
    removeItem: "Fjern element"
  },
  fr: {
    removeItem: "Supprimer l'objet"
  },
  es: {
    removeItem: "Eliminar elemento"
  },
  pl: {
    removeItem: "Usuń element"
  },
  ro: {
    removeItem: "Eliminați elementul"
  },
  hr: {
    removeItem: "Ukloni element"
  },
  cs: {
    removeItem: "Odstraňte prvek"
  },
  sl: {
    removeItem: "Odstráňte prvok"
  }
};
